// import { sentryConfig as sentryConfigProd } from './sentry.config.prod';

export const environment = {
  production: true,
  disableLogging: true,
  encryptionPassword: 'UcK*hCW(7qcf{N3d',
  fmKey: 'KSGygdCfLVjbaQCPfHqwtY',
  // PROD
  apiUrl: 'https://prod-api-alfaromeo.one3d.in/api/v1/alfaromeo-junior/',
  function_js: 'one3d_functions.js',
  assetsUrl: 'https://dote1tj22aj27.cloudfront.net/assets/one3d/',

  cdnImage: 'https://d1y82e0jn69ge0.cloudfront.net/',
  jeepUrl: 'https://www.jeep.com.au',
  carExchangeUrl:
    'https://jeepselectedforyou.in/used-car-valuation/?token=WS1ngjLGRSab13D8jTdU6dTrh',
  hideTutorialModels: ['WL75', 'JL24'],
  appName: 'alfa-romeo-australia-web' as string | undefined,
  appRelease: 'alfa-romeo-australia-prod' as string | undefined,
  // Sentry Settings (disabled)
  // ...sentryConfigProd,
};
